import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { UIactions } from "../../../../../store/slices/UI";
import { workerActions } from "../../../../../store/slices/workers";
import { repoPickerId } from "../../../../UI/Specialized/RSRepositoryPicker";

const UIText = {
  "es-CL": {
    success: "Cambio de selección de repositorio completo exitoso.",
    error: "Error al cambiar la selección de repositorio completo: ",
  },
  "en-US": {
    success: "Full repository selection change successful.",
    error: "Error changing full repository selection: ",
  },
}

export const allSelectId = "allSelect";
export const allDeSelectId = "allDeSelect";

const c365fullRepoChange = ({ user, mid, M365server, server, cloner_key, selectAll=false, tunnelToken, locale }) => {
  let handler = ":5111/remote/repo/greylist/set/all";
  const { success, error } = UIText[locale] || UIText["es-CL"];

 let id
 if (selectAll){
  id = allSelectId;
 } else {
  id = allDeSelectId;
 }

  return async (dispatch) => {
    dispatch(workerActions.start(id));
    try {
      const base = M365server.split(":");
      const url = base[0]+":" + base[1] + handler;

      const bodyData = JSON.stringify({ login:user, scan_folder: selectAll });

      await axios.post(url, bodyData, { headers: { cloner_key, tunnel_token:tunnelToken  } });

        enqueueSnackbar(success, { variant: "success" });
        dispatch(workerActions.finish({ id  }));
        dispatch(UIactions.clear(repoPickerId));
        // dispatch(workerActions.clear(getM365OrgId));
    } catch (e) {
        enqueueSnackbar(error + e.message, { variant: "error" });
        dispatch(workerActions.finish({ id, error }));
    }
    // try {
    // const base = M365server.split(":");
    //   let url = base[0] + handler;
    //   console.log("Starting session with url:", url);

    //   let formData = new FormData();
    //   formData.append("user", user);
    //   formData.append("machine", mid);
    //   const response = await axios.post(url, formData, {
    //     headers: { "Content-Type": "multipart/form-data", cloner_key },
    //   });
    //   dispatch(
    //     UIactions.setValue({ id: tunnelTokenId, value: response.data.token })
    //   );

    //   const tunnel_token = response.data.token;
    //   const response2 = await axios.get(url2, { headers: { tunnel_token } });
    //   const response3 = await axios.get(url3, { headers: { tunnel_token } });

    //   const repos = response2.data.repos;
    //   const roots = response3.data.roots;
    //   const ids = response3.data.ids;
    //   const sizes = response3.data.space_sizes;

    //   // console.log("sizes: ", sizes);

    //   // console.log("repos: ", repos);
    //   // console.log("roots: ", roots);
    //   // console.log("ids: ", ids);

    //   let newRoots = [];
    //   let i = 0;
    //   for (const root of roots) {
    //     const found = repos.find((x) => x.name === root);
    //     // const size = sizes.find((s) => s.root === root);
    //     let newRoot;
    //     if (is365device) {
    //       console.log("c365 device")
    //       const size = sizes.find((s) => s.id === ids[i]);
    //       // console.log("size", size)
    //       newRoot = { c365ID: ids[i], id: null, root, size: size.space_used };
    //     } else {
    //       console.log("not c365 device")
    //       newRoot = { id: null, root };
    //     }

    //     if (found) {
    //       // console.log("found a ",root)
    //       newRoot.id = found.id;
    //     } else {
    //       // console.log("not found a ",root)
    //     }
    //     newRoots.push(newRoot);
    //     i++
    //   }
    //   dispatch(warehouseActions.load({ id: rootsDataId, data: newRoots }));
    // } catch (e) {
    //   console.error(e);
    //   dispatch(workerActions.finish({ id: tunnelTokenId, error: e.message }));
    // }
    // dispatch(workerActions.finish({ id: tunnelTokenId }));
  };
};

export default c365fullRepoChange;
